var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgParcking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375,
    height: 812,
    viewBox: "0 0 375 812",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 812,
    fill: "url(#paint0_linear_1239_3227)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1239_3227",
    x1: 418.527,
    y1: -580,
    x2: -859.299,
    y2: 419.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27272,
    stopColor: "#2B114B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741868,
    stopColor: "#4C2182"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgParcking);
export default __webpack_public_path__ + "static/media/bg-parcking.8ce4f70b08be30dab94b703b9515c6ac.svg";
export { ForwardRef as ReactComponent };